import synopsis from '../../../assets/img/story/1.png'
import univers from '../../../assets/img/story/2.png'
import declenchement from '../../../assets/img/story/3.png'
import aventure from '../../../assets/img/story/4.png'
import denouement from '../../../assets/img/story/5.png'

//Array all story images
let storyImage = []
storyImage.push(synopsis, univers, declenchement, aventure, denouement)

export default class Story {
  constructor() {
    this.story = document.createElement('div')
    this.storyImage = {}
    this.addStoryBlock()

    this.animPages()
  }
  addStoryBlock() {
    //Story
    this.story.className = 'story'

    //Story wrapper
    this.storyWrapper = document.createElement('div')
    this.storyWrapper.className = 'story_wrapper'
    this.story.appendChild(this.storyWrapper)

    //story indicator
    this.indicator = document.createElement('p')
    this.indicator.className = 'story_indicator'
    this.indicator.innerText = 'Clicker pour passer'
    this.storyWrapper.appendChild(this.indicator)

    //button
    this.pageNotionLink = document.createElement('a')
    this.pageNotionLink.setAttribute('target', '_blank')
    this.pageNotionLink.innerHTML = 'Découvrez la méthode'
    this.pageNotionLink.className = 'notion_link'
    this.pageNotionLink.href = 'https://bush-peacock-fc8.notion.site/Nous-sommes-tous-Designers-ca5fa56c82c64135b1ccc00ef1430e4b'
    this.story.appendChild(this.pageNotionLink)

    //StoryBlock
    this.storyBook = []

    //Story Page
    this.storyPage = {}
    this.storyPage = document.createElement('div')
    this.storyPage.className = 'story_page'

    //storyImage
    this.storyPage.storyImage = document.createElement('img')
    this.storyPage.storyImage.className = 'story_img'
    this.storyPage.storyImage.src = synopsis
    this.storyPage.appendChild(this.storyPage.storyImage)

    //story Title
    this.storyPage.storyTitle = document.createElement('h2')
    this.storyPage.storyTitle.className = 'story_title'
    this.storyPage.storyTitle.innerText = '1.Synopsis'
    this.storyPage.appendChild(this.storyPage.storyTitle)

    //story Description
    this.storyPage.storyDescription = document.createElement('p')
    this.storyPage.storyDescription.className = 'story_description'
    this.storyPage.storyDescription.innerText =
      'Tout commence par une histoire où l’utilisateur en est le principal protagoniste dans un univers où son expérience est le fil conducteur de votre scénario'
    this.storyPage.appendChild(this.storyPage.storyDescription)
  }

  createPages() {
    //create 5 pages
    for (let index = 0; index < 5; index++) {
      this.storyBook.push(this.storyPage)
      this.storyWrapper.appendChild(this.storyPage.cloneNode(true))

      if (index === 0) {
        this.storyPage.storyTitle.innerHTML = '2.Univers'
        this.storyPage.storyDescription.innerHTML = "Un monde nouveau qu'il va découvrir et appréhender avec une certaine supposition, basée sur ses expériences passées."
        this.storyPage.storyImage.src = univers
      }
      if (index === 1) {
        this.storyPage.storyTitle.innerHTML = '3.Déclenchement'
        this.storyPage.storyDescription.innerHTML = "Le héros arrive avec une quête à accomplir, une idée en tête, une attente singulière émanant d'un problème à résoudre."
        this.storyPage.storyImage.src = declenchement
      }
      if (index === 2) {
        this.storyPage.storyTitle.innerHTML = '4.Aventure'
        this.storyPage.storyDescription.innerHTML =
          "Une aventure séquentielle, un parcours itératif qui va le mener sur différentes étapes. Surmonter des obstacles, trouver des opportunités pour s'orienter et réussir ses objectifs."
        this.storyPage.storyImage.src = aventure
      }
      if (index === 3) {
        this.storyPage.storyTitle.innerHTML = '5.Dénouement'
        this.storyPage.storyDescription.innerHTML =
          "Une fois la mission accomplie ou même en cas d'échec, le héros en sortira grandit, différent, avec un sentiment basé sur son ressenti."
        this.storyPage.storyImage.src = denouement
      }
    }
  }

  async animPages() {
    await this.createPages()

    const story = document.querySelector('.story_wrapper')
    const storyPages = [...document.querySelectorAll('.story_page')]
    const spSlide = storyPages.length
    let count = 0
    storyPages[0].classList.add('active')

    function nextPage() {
      storyPages[count].classList.remove('active')
      if (count < spSlide - 1) {
        count++
      } else {
        count = 0
      }
      storyPages[count].classList.add('active')
    }
    story.addEventListener('click', nextPage)
  }
}
